{
  "nickname": "ชื่อเล่น",
  "userId": "รหัสผู้ใช้",
  "userIdValue": "UID{{id}}",
  "connectedAppsDate": "{{label}}: {{date}}",
  "kyc": "ยืนยันตัวตน",
  "loginPassword": "รหัสผ่านเข้าสู่ระบบ",
  "txPassword": "รหัสผ่านทำรายการ",
  "paymentMethod": "วิธีรับหรือชำระเงิน",
  "connectedApps": "แอปที่เชื่อมต่อ",
  "connectedAppsNotConnected": "ไม่ได้เชื่อมต่อ",
  "connectedAppsEmpty": "ยังไม่มีแอปที่เชื่อมต่อ",
  "connectedAppsConnectedAt": "เวลาเชื่อมต่อ",
  "connectedAppsLastUsedAt": "ใช้งานล่าสุด",
  "connectedAppsDisconnect": "ตัดการเชื่อมต่อ",
  "connectedAppsDisconnectTitle": "ตัดการเชื่อมต่อแอป",
  "connectedAppsDisconnectDesc": "หลังตัดการเชื่อมต่อ แอปนี้จะไม่สามารถใช้ {{token}} เพื่อชำระเงินได้",
  "connectedAppsDisconnectSuccess": "ตัดการเชื่อมต่อแล้ว",
  "connectedAppsDisconnectFailed": "ตัดการเชื่อมต่อไม่สำเร็จ",
  "connectAppTitle": "เชื่อมต่อแอป",
  "connectAppName": "ชื่อแอป",
  "connectAppOrder": "หมายเลขคำสั่งซื้อแอป",
  "connectAppExpiresAt": "วันหมดอายุ",
  "connectAppConfirmDesc": "เมื่อยืนยันแล้ว แอปนี้จะใช้ {{token}} เพื่อชำระเงินได้ภายใต้การอนุญาตของคุณ",
  "connectAppConfirm": "ยืนยันการเชื่อมต่อ",
  "connectAppApproveSuccess": "เชื่อมต่อสำเร็จ",
  "connectAppApproveFailed": "เชื่อมต่อไม่สำเร็จ",
  "notification": "การตั้งค่า",
  "contactCS": "ติดต่อฝ่ายบริการลูกค้า",
  "logoutTitle": "ยืนยันออกจากระบบ",
  "logoutDesc": "คุณแน่ใจว่าต้องการออกจากระบบหรือไม่",
  "logout": "ออกจากระบบ",
  "cancel": "ยกเลิก",
  "version": "เวอร์ชัน",
  "phone": "หมายเลขโทรศัพท์",
  "notVerified": "ยังไม่ยืนยัน",
  "kycRejected": "ไม่ผ่านการตรวจสอบ",
  "kycReviewing": "กำลังตรวจสอบ",
  "kycVerified": "ตรวจสอบแล้ว",
  "notAdded": "ยังไม่ได้เพิ่ม",
  "set": "ตั้งค่าแล้ว",
  "notSet": "ยังไม่ได้ตั้งค่า",
  "nicknameNotSet": "ยังไม่ได้ตั้งชื่อเล่น",
  "copied": "คัดลอกแล้ว",
  "upgradeGuide": "คู่มืออัปเกรด",
  "upgradeHint": "ทำตามเงื่อนไขเพื่ออัปเกรดและรับสิทธิประโยชน์เพิ่ม!"
}
